/**
 * AppearanceSettings (OCP-335) — theme picker (System / Light / Dark)
 * for the App settings area. Backed by ThemeContext (persists to
 * localStorage; applies the `dark` class on <html>).
 */
import { useTheme, type Theme } from '../contexts/ThemeContext';

const OPTIONS: { value: Theme; label: string; hint: string }[] = [
  { value: 'system', label: 'System', hint: 'Follow your device setting' },
  { value: 'light', label: 'Light', hint: 'Always light' },
  { value: 'dark', label: 'Dark', hint: 'Always dark' },
];

export function AppearanceSettings() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  return (
    <div className="rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4 shadow-sm">
      <div className="text-sm font-semibold text-gray-900 dark:text-gray-100">Theme</div>
      <div className="mt-0.5 text-xs text-gray-500">
        Choose how orboto Control looks on this device. Currently showing{' '}
        <span className="font-medium">{resolvedTheme}</span>.
      </div>
      <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-3">
        {OPTIONS.map((o) => {
          const active = theme === o.value;
          return (
            <button
              key={o.value}
              type="button"
              onClick={() => setTheme(o.value)}
              aria-pressed={active}
              className={`flex flex-col items-start rounded-lg border px-3 py-2.5 text-left ${
                active
                  ? 'border-brand-500 ring-1 ring-brand-500 bg-brand-50 dark:bg-brand-900/20'
                  : 'border-gray-300 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800/60'
              }`}
            >
              <span className="text-sm font-medium text-gray-900 dark:text-gray-100">{o.label}</span>
              <span className="mt-0.5 text-xs text-gray-500">{o.hint}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
